import type { QuantityDisplayRule } from '@/types'

export function getStockQuantityDisplayText(
  quantity: number | null | undefined,
  displayRules?: QuantityDisplayRule[]
): string | null {
  if (
    quantity === null ||
    quantity === undefined ||
    Number.isNaN(Number(quantity))
  ) {
    return null
  }

  const matchedRule = displayRules?.find((rule) => {
    const min = rule.min ?? Number.NEGATIVE_INFINITY
    const max = rule.max ?? Number.POSITIVE_INFINITY

    return quantity >= min && quantity <= max
  })

  return matchedRule?.displayText?.trim() || null
}

export function formatStockQuantity(
  quantity: number | null | undefined,
  unit?: string,
  displayRules?: QuantityDisplayRule[],
  fallback = '-'
): string {
  const displayText = getStockQuantityDisplayText(quantity, displayRules)

  if (displayText) return displayText
  if (!quantity) return fallback

  return `${quantity} ${unit ?? ''}`.trim()
}
